import { useWallet } from "../wallet/WalletContext";

export function WalletButton() {
  const { account, connecting, connect, disconnect } = useWallet();

  if (account) {
    return (
      <button className="btn btn--outline" onClick={disconnect} title="Click to disconnect">
        {account}
      </button>
    );
  }

  return (
    <button className="btn btn--primary" onClick={connect} disabled={connecting}>
      {connecting ? "Connecting…" : "Connect Wallet"}
    </button>
  );
}
